import { useMutation, UseMutationOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'

export namespace PostResetPasswordEmail {
  export type Response = any
  export type Variables = { email: string }
  export type Error = Api.Error
  export type Options = UseMutationOptions<Response, Error, Variables>
}

export const usePostResetPasswordEmail = (options?: PostResetPasswordEmail.Options) => {
  const mutationFn = async (data: PostResetPasswordEmail.Variables) => {
    return ApiClient.post<PostResetPasswordEmail.Response>('/v1/clients/password/forgot', {
      data,
    })
  }

  const mutation = useMutation<
    PostResetPasswordEmail.Response,
    PostResetPasswordEmail.Error,
    PostResetPasswordEmail.Variables
  >(mutationFn, options)

  return { ...mutation, postResetPasswordEmail: mutation.mutate }
}
